import { ToastConfig } from '@ngxpert/hot-toast';

export const TOAST_CONFIG: Partial<ToastConfig> = {
  dismissible: true,
  ariaLive: 'polite',
  stacking: 'depth',
  role: 'alert',
  success: {
    iconTheme: {
      primary: '#16a34a',
      secondary: '#f0fdf4'
    },
    style: {
      background:'#f0fdf4',
    }
  },
  info: {
    iconTheme: {
      primary: '#2563eb',
      secondary: '#eff6ff'
    },
    style: {
      background:'#eff6ff',
    }
  },
  warning: {
    iconTheme: {
      primary: '#ca8a04',
      secondary: '#fefce8'
    },
    style: {
      background:'#fefce8',
    }
  },
  error: {
    iconTheme: {
      primary: '#dc2626',
      secondary: '#fef2f2'
    },
    style: {
      background:'#fef2f2',
    }
  },
};
